/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-29 15:29:32
 *
 *******************************************************/
// @flow
// DONE
export const FILTER_SETTINGS_PAGINATION_TYPES = [
  { value: 'default', label: 'AdminHTML.FilterSettings.Constant.paginationTypes_Default_Label' },
  { value: 'infinite', label: 'AdminHTML.FilterSettings.Constant.paginationTypes_Infinite_Label' },
  { value: 'load_more', label: 'AdminHTML.FilterSettings.Constant.paginationTypes_LoadMore_Label' }
];

export const FILTER_SETTINGS_SORTING_TYPES = [
  { value: 'relevance', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option1_Label' },
  { value: 'best-selling', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option2_Label' },
  { value: 'manual', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option3_Label' },
  { value: 'price-ascending', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option4_Label' },
  { value: 'price-descending', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option5_Label' },
  { value: 'title-ascending', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option6_Label' },
  { value: 'title-descending', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option7_Label' },
  { value: 'created-descending', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option8_Label' },
  { value: 'created-ascending', label: 'AdminHTML.FilterSettings.Constant.sortingType_Option9_Label' }
];

export const FILTER_SETTINGS_FONT_WEIGHT = [
  { value: '', label: 'AdminHTML.FilterSettings.Constant.selectDefaultValue' },
  { value: '300', label: '300' },
  { value: '400', label: '400' },
  { value: '500', label: '500' },
  { value: '600', label: '600' },
  { value: '700', label: '700' },
  { value: '800', label: '800' },
  { value: '900', label: '900' }
];

export const FILTER_SETTINGS_FONT_TRANSFORM = [
  { value: '', label: 'AdminHTML.FilterSettings.Constant.selectDefaultValue' },
  { value: 'none', label: 'AdminHTML.FilterSettings.Constant.fontTransform_Option1_Label' },
  { value: 'capitalize', label: 'AdminHTML.FilterSettings.Constant.fontTransform_Option2_Label' },
  { value: 'uppercase', label: 'AdminHTML.FilterSettings.Constant.fontTransform_Option3_Label' },
  { value: 'lowercase', label: 'AdminHTML.FilterSettings.Constant.fontTransform_Option4_Label' },
  { value: 'initial', label: 'AdminHTML.FilterSettings.Constant.fontTransform_Option5_Label' },
  { value: 'inherit', label: 'AdminHTML.FilterSettings.Constant.fontTransform_Option6_Label' }
];

export const FILTER_SETTINGS_OUT_OF_STOCK__DISPLAY_OPTION = [
  { value: 'show', label: 'AdminHTML.FilterSettings.Constant.outOfStockDisplayOption_Show_Label' },
  { value: 'hide', label: 'AdminHTML.FilterSettings.Constant.outOfStockDisplayOption_Hide_Label' },
  { value: 'hideAfterFiltering', label: 'AdminHTML.FilterSettings.Constant.outOfStockDisplayOption_HideAfterFiltering_Label' }
];
